import { motion } from "framer-motion";
import { waLink } from "../config/site";
import { WhatsAppIcon } from "./DealerSection";

const WhatsAppFloat = () => (
  <motion.a
    data-testid="whatsapp-float-button"
    href={waLink("Hello TMV Coffee, I would like to place an order / enquiry.")}
    target="_blank"
    rel="noopener noreferrer"
    aria-label="Chat with TMV Coffee on WhatsApp"
    className="group fixed bottom-6 right-6 z-50 flex items-center gap-3"
    initial={{ opacity: 0, scale: 0.6 }}
    animate={{ opacity: 1, scale: 1 }}
    transition={{ delay: 1.6, duration: 0.5, ease: [0.22, 1, 0.36, 1] }}
  >
    <span className="hidden rounded-full bg-cream px-4 py-2 text-[11px] font-medium uppercase tracking-[0.15em] text-espresso opacity-0 shadow-lg transition-all duration-300 group-hover:opacity-100 md:block">
      Chat with us
    </span>
    <span className="relative flex h-14 w-14 items-center justify-center rounded-full bg-whatsapp text-white shadow-[0_10px_30px_-8px_rgba(37,211,102,0.6)] transition-transform duration-300 group-hover:scale-105">
      <span className="wa-pulse-ring absolute inset-0 rounded-full bg-whatsapp" aria-hidden="true" />
      <WhatsAppIcon className="relative h-6 w-6" />
    </span>
  </motion.a>
);

export default WhatsAppFloat;
